
<div class="AppFooter">
    <div class="">
        <span class="Hint">TaxiFusion © {{ currentYear }}</span>
    </div>
</div>
